export default defineNuxtRouteMiddleware((to, from) => {
    let navigationType = checkForNavigation(to, from)
    onConsented(() => {
        const sessIdent = useCurrentSessionIdentifier()?.value
        if (sessIdent != undefined && sessIdent != null) {
            useGeneralTrick({
                eventType: "VIEW_PAGE",
                sessionId: sessIdent,
                json: {
                    content: to.path,
                    url: [[to?.fullPath]],
                    refferer: from?.fullPath,
                    from: from?.path,
                    lastActions: useLastActions()?.value,
                    navigationType: navigationType
                },
            }, to);
            if (useLastActions()?.value?.length)
                useLastActions().value.length = 0;
        }
    })
})


function checkForNavigation(to, from) {
    let response: string
    if(to?.path == from?.path && useLastNavigationPoint().value == from?.path) {
        console.debug("CHANGE RELOAD")
        response = '1'
    }
    else if(useLastNavigationPoint().value == to?.path) {
        console.debug("CHANGE RETURN")
        response = '2'
    } else {
        response = '0'
    }
    useLastNavigationPoint().value = from.path
    return response
}

